/*
 *
 * Settings reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_SETTINGS,
  LOAD_SETTINGS,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_ERROR,
  CHANGE_SETTINGS,
  CHANGE_SETTINGS_SUCCESS,
  CHANGE_SETTINGS_ERROR,
  DELETE_SETTINGS,
  DELETE_SETTINGS_SUCCESS,
  DELETE_SETTINGS_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  settingsList: false,
  settingsData: false,
};

/* eslint-disable default-case, no-param-reassign */
const settingsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_SETTINGS:
        return initialState;

      // LOAD
      case LOAD_SETTINGS:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_SETTINGS_SUCCESS:
        draft.settingsList = action.settingsList;
        draft.loading = false;
        break;

      case LOAD_SETTINGS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_SETTINGS:
        draft.settingsData = { ...state.settingsData, ...action.settingsData };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_SETTINGS_SUCCESS:
        draft.loading = false;
        const { settingsData } = action;
        draft.settingsData = settingsData;

        // update single item in the list inside state
        let listData = draft.settingsList.data;
        let index = draft.settingsList.data.findIndex(
          po => po._id === settingsData._id,
        );
        index !== -1
          ? (listData[index] = settingsData)
          : listData.unshift(settingsData);
        draft.settingsList = { ...draft.settingsList, data: listData };

        break;

      case CHANGE_SETTINGS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_SETTINGS:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_SETTINGS_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default settingsReducer;
